const DEFAULT_MESSAGE = 'An error occurred. Please try again later.';

const handleErrorMessage = (error: unknown): string => {
  if (error instanceof APIError) {
    const message = error.details
      ? error.details.map(({ message }) => message).join('\n') 
      : error.message;

    return message.trim() || DEFAULT_MESSAGE;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return DEFAULT_MESSAGE;
};

export default { handleErrorMessage };
